(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};


const Events = svs.tur.ball.constants;
const Animations = svs.tur.ball.animations.Core;
const HuxFluxAnimations = svs.tur.ball.animations.HuxFlux;
const {
  getRules
} = svs.numbergames.rules;
class Default extends svs.tur.Base {
  constructor(options) {
    var _getRules, _options$min, _options$max;
    options.className = 'ball';
    super(options);
    const {
      numbersMaxValue = 0,
      numbersExtraMaxValue = numbersMaxValue
    } = (_getRules = getRules(options)) !== null && _getRules !== void 0 ? _getRules : {};
    this.min = (_options$min = options.min) !== null && _options$min !== void 0 ? _options$min : 1;
    this.max = (_options$max = options.max) !== null && _options$max !== void 0 ? _options$max : this.extraNumber ? numbersExtraMaxValue : numbersMaxValue;
    this.createDomElements();
    this.isHuxFluxable = true;
    this.size && this.$el.classList.add("ball-".concat(this.size));
  }
  createDomElements() {
    this.$bg = this.createAndAddElement({
      className: 'bg'
    });

    this.$inner = this.createElement('inner');
    this.$number = this.createElement('number', 'span');
    this.setNumber(this.number);
    this.$inner.appendChild(this.$number);
    this.$el.appendChild(this.$inner);
  }
  classNames() {
    return ['ball-default'];
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    return this.$el;
  }
  setNumber(number) {
    if (number !== undefined) {
      if (number > this.max) {
        this.log.info("You cannot set a higher number (".concat(number, ") than"), this.max);
      } else {
        const isVikinglottoExtraBall = svs.numbergames.productMapping.isVikinglotto(this.productId) && this.extraNumber;
        this._previousNumber = this.number;
        this.number = number;
        this.$el.setAttribute('data-id', number);
        if (isVikinglottoExtraBall) {
          this.$number.innerHTML = svs.numbergames.rules.utils.vikinglotto.getVikingNumberSvg(number);
        } else {
          this.$number.innerText = number;
        }
        this.trigger(Events.BALL_UPDATED, this);
      }
    }
  }
  clearNumber() {
    if (!this.$el) return;
    this.number = null;
    this.$el.removeAttribute('data-id');
    this.$number.innerText = '';
    this.trigger(Events.BALL_UPDATED, this);
  }
  hideNumber() {
    if (this.$number) {
      this.$number.style.opacity = 0;
    }
  }
  showNumber() {
    if (this.$number) {
      this.$number.style.opacity = 1;
    }
  }
  show() {
    this.$el.style.opacity = 1;
  }
  hide() {
    this.$el.style.opacity = 0;
  }
  fadeIn() {
    return Animations.fadeIn(this);
  }
  rollIn() {
    return Animations.rollIn(this);
  }
  bounceIn() {
    return Animations.bounceIn(this);
  }
  wave() {
    return Animations.wave(this);
  }
  shrink() {
    return Animations.shrink(this);
  }
  grow() {
    return Animations.grow(this);
  }
  delete() {
    this.trigger(Events.BALL_DELETED, this);
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    const self = this;
    for (const i in self) {
      if ({}.hasOwnProperty.call(self, i)) {
        delete self[i];
      }
    }
  }
  huxflux() {
    if (this._huxfluxToNumber >= this.min && this._huxfluxToNumber <= this.max) {
      return HuxFluxAnimations.start(this, this._huxfluxToNumber);
    }
  }
  swapToHuxfluxedNumber() {
    if (this._huxfluxToNumber >= this.min && this._huxfluxToNumber <= this.max) {
      this.setNumber(this._huxfluxToNumber);
    }
  }
  prepare(huxfluxToNumber) {
    if (this.isHuxFluxable) {
      if (huxfluxToNumber >= this.min && huxfluxToNumber <= this.max) {
        this._huxfluxToNumber = huxfluxToNumber;
        return true;
      }
      this.log.info("You must pass a valid number, you passed ".concat(huxfluxToNumber, ". Min is ").concat(this.min, " and max is ").concat(this.max, "!"));
      this._huxfluxToNumber = null;
    } else {
      if (typeof huxfluxToNumber !== 'undefined' && this.log) {
        this.log.info('This ball is not huxfluxable!');
      }
      this._huxfluxToNumber = null;
    }
    return false;
  }
  clear() {
    return Animations.clear(this);
  }
}
svs.tur.ball.Default = Default;

 })(window);